import state from "./modulePrivatePlotState.js";
import mutations from "./modulePrivatePlotMutations.js";
import actions from "./modulePrivatePlotActions.js";
import getters from "./modulePrivatePlotGetters.js";

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
